import { useQuery } from "@apollo/client";

import { GET_ORIGIN_BUILT_IN_INTEGRATION } from "./gql";

const useGetOriginIntegration = () => {
  const { data, loading, error, refetch } = useQuery(GET_ORIGIN_BUILT_IN_INTEGRATION, {
    fetchPolicy: "cache-and-network",
  });

  return {
    loading,
    error,
    refetch,
    originIntegration: data?.originIntegration ?? undefined,
  };
};

export default useGetOriginIntegration;
